<template>
  <div>
    <vx-card class="mb-4">
      <div class="flex flex-col gap-4">
        <validation-observer ref="validator" #default="{valid}">
          <b-form @submit.prevent="createOrUpdate">
            <div class="vx-row">
              <div class="vx-col w-8/12">
                <div v-if="isEdit()">
                    <b-form-group
                      :label="$t('portal_cebas.credentialing.legal_entity')"
                      label-for="credentialing_config_legal_entity">
                      <b-form-input
                        id="credentialing_config_legal_entity"
                        v-model="model.legal_entity.trading_name"
                        name="credentialing_config_legal_entity"
                        readonly/>
                    </b-form-group>
                  </div>
                  <div v-else>
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('portal_cebas.credentialing.legal_entity')"
                      rules="required"
                      class="flex-grow"
                      slim>
                      <select-suggestion v-if="!isEdit()"
                        column="company_name,trading_name,cnpj"
                        model="LegalEntity"
                        v-model="selectedLegalEntity"
                        label="Pessoa Jurídica"
                        :appendClearOption="true"
                        placeholderText="Digite o nome da instituição"
                        :itemTextFormat="legalEntityItemTextFormat"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
              </div>
            </div>
            <!-- -->
            <div class="vx-row pt-1">
              <div class="vx-col w-full">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('portal_cebas.credentialing.link')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    id="credentialing_config_link"
                    :label="$t('portal_cebas.credentialing.link')"
                    label-for="credentialing_config_link">
                    <b-form-input
                      id="credentialing_config_link"
                      v-model="model.link"
                      :state="errors.length > 0 ? false:null"
                      name="credentialing_config_link"
                      class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                        <span class="align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                          v-clipboard:copy="exemploLink"
                          v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
                          v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
                          v-tooltip.top="{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}"
                          >
                          <feather-icon
                              icon="LinkIcon"
                              svgClasses="h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"/>
                          {{exemploLink}}
                        </span>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="text-primary">
                 Link para consulta pública (protocolo):
                </label>
                <span class="align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                    v-clipboard:copy="queryLinkPublicProtocol"
                    v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
                    v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
                    v-tooltip.top="{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}"
                    >
                    <feather-icon
                        icon="LinkIcon"
                        svgClasses="h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"/>
                    {{queryLinkPublicProtocol}}
                  </span>
              </div>
            </div>
            <!-- -->
            <div class="vx-row pt-1">
              <div class="vx-col w-full">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('portal_cebas.credentialing.title_page')"
                  rules="required"
                  class="flex-grow"
                  slim>
                  <b-form-group
                    :label="$t('portal_cebas.credentialing.title_page')"
                    label-for="credentialing_config_title_page">
                    <b-form-input
                      id="credentialing_config_title_page"
                      v-model="model.title_page"
                      :state="errors.length > 0 ? false:null"
                      name="credentialing_config_title_page"
                      class="required"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <b-form-group
                  :label="$t('portal_cebas.credentialing.info_page')"
                  label-for="content">
                  <complex-editor :editor_data.sync="model.info_page"/>
                </b-form-group>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full mb-2">
                <vs-divider class="m-1">Notificação para Interessados</vs-divider>
                <b-form-group
                    :label="$t('receiving_emails')"
                    label-for="emailsInput">

                    <!--Tags input-->
                    <emails-input
                      ref="emailsInput"
                      :emailsInput="emailsInitialTag"
                      @emailsChanged="emailsChanged"
                      :sendButton="false"/>
                </b-form-group>
              </div>
            </div>
          </b-form>
          <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!valid"
                v-permission="'portal_cebas.credentialing.config.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                v-permission="'portal_cebas.credentialing.config.edit'"
                @click="createOrUpdate"
                variant="primary"
                :disabled="!valid">
                {{ $t('action.save') }}
              </b-button>
            <b-button
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
            </b-button>
          </div>
        </validation-observer>
      </div>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { v4 as uuidv4 } from 'uuid'
import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BIconClipboard,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max } from '@validations'
import SelectSuggestion from '@/components/SelectSuggestion.vue'
import ComplexEditor from '@/components/ComplexEditor.vue'
import EmailsInput from '@/components/EmailsInput.vue'

import CebasCredentialingConfigService from '@/services/api/cebas/CebasCredentialingConfigService'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BIconClipboard,
    BFormInvalidFeedback,
    // validations
    ValidationProvider,
    ValidationObserver,
    // Custom
    SelectSuggestion,
    ComplexEditor,
    EmailsInput,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    model: {
      id: null,
      legal_entity_id: null,
      legal_entity: {
        trading_name: ''
      },
      link: '',
      info_page: '',
      title_page: '',
      emails: [],
      emailsInitialTag: [],
    },
    selectedLegalEntity: null,
    //Validation
    required, min, max,
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.title_page)
            && !this.isEmpty(_.get(this.model, 'link'))
            && (this.selectedLegalEntity && !this.isEmpty(this.selectedLegalEntity.id))
    },
    exemploLink(){
      return `${this.protocolLocation()}/#/portal-cebas/credentialings/pub/${_.kebabCase(this.model.link)}`
    },
    queryLinkPublicProtocol(){
      return _.get(this.model, 'url_public_protocol_query', `${this.protocolLocation()}/#/form-protocol-query/cebas-credentialing`)
    },
  },
  watch: {

  },
  beforeMount() {
    this.service = CebasCredentialingConfigService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
    if(!this.isEdit()){
      if(!this.model.link){
        this.model.link = this._.kebabCase(uuidv4())
      }
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
          this.emailsInitialTag = _.get(response, 'data.emails');
          this.selectedLegalEntity = response.legal_entity
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(() => {this.$vs.loading.close()})
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        link: this._.kebabCase(this.model.link),
        info_page: this.model.info_page,
        title_page: this.model.title_page,
        legal_entity_id: this.selectedLegalEntity.id,
        emails: this.emails
      }

      this.service.createOrUpdate(modelData).then(
        response => {
          this.id = response.id
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          if(!this.isEdit()){
            this.$router.push(`/portal-cebas/credentialings/configs/${this.id}/edit`)
          }
        },
        error => {
          this.showErrors(this.$validator, error)
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    goBack() {
      this.$router.push('/portal-cebas/credentialings/configs')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
    legalEntityItemTextFormat(model){
      if (this._.isEmpty(model)) return ''

      let string = `${model.company_name} - ${model.trading_name}`

      if (model.cnpj) {
        string = `${string} (${this.cnpjFormat(model.cnpj)})`
      }

      return string
    },
    emailsChanged(emails) {
      this.emails = emails
    }
  }
}
</script>

<style>

</style>
